module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_TI.7d6699e4.txt";